import { forwardRef, useMemo } from 'react';
import { AccountModesEnum } from '@/api/amlbotAPI';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { SidebarNav } from '@/components';

import amlbotLogo from '@/assets/images/logo-amlbot.svg';
import { useAppSelector } from '@/redux/hooks';
import { profileSelectors } from '@/redux/selectors';
import useDevice from '@/hooks/useDevice';

import styles from './Sidebar.module.sass';

interface SidebarProps {
  isActive?: boolean;
  onClose?: () => void;
}

export const Sidebar = forwardRef<HTMLDivElement | null, SidebarProps>(
  (props, ref) => {
    const { isActive = false, onClose } = props;
    const { isMobile } = useDevice();

    const { data: profileData } = useAppSelector(
      profileSelectors.getProfileSlice,
    );

    const isB2B = useMemo(() => {
      return profileData?.isB2B;
    }, [profileData?.isB2B]);

    const modeTag = useMemo(() => {
      switch (profileData?.accountMode) {
        case AccountModesEnum.LITE:
          return 'Lite';
        case AccountModesEnum.PRO:
          return 'Pro';
        case AccountModesEnum.PRO_PLUS:
          return 'Pro+';
        default:
          return '';
      }
    }, [profileData?.accountMode]);

    const classes = cx(styles.sidebar, {
      [styles['is-active']]: isActive,
    });

    return (
      <>
        {isActive && isMobile && (
          <div className={styles.backdrop} onClick={onClose} />
        )}
        <aside className={classes} ref={ref}>
          <Link to="/" className={styles.logo}>
            <img src={amlbotLogo} alt="AMLBot" />
            {modeTag && <span className={styles.mode}>{modeTag}</span>}
          </Link>

          <SidebarNav isB2B={isB2B} />
        </aside>
      </>
    );
  },
);

export default Sidebar;
